<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="1000" persistent>
        <v-card class="rounded-xl overflow-hidden shadow-xl d-flex flex-column" style="background-color: #f8fafc;">
            <!-- Header matching VehicleEdit.vue bg -->
            <v-card-title class="py-4 px-6 d-flex align-center primary text-white">
                <div class="d-flex align-center flex-grow-1 min-w-0 mr-4">
                    <div class="plate-badge mr-3 flex-shrink-0">
                        {{ selectedVehicleDetails ? selectedVehicleDetails.VehPlate : '...' }}
                    </div>
                    <div class="min-w-0">
                        <h2 class="text-h6 font-weight-bold white--text block truncate"
                            style="line-height: 1.2; margin: 0;">
                            Auditar Vehículo
                        </h2>
                        <span class="text-caption block truncate" style="color: rgba(255, 255, 255, 0.75) !important;">
                            {{ selectedVehicleDetails ?
                                selectedVehicleDetails.SpcCompanyName : 'Cargando transportista...' }}
                        </span>
                    </div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeAuditModal()" class="close-icon-btn">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <!-- Segmented iOS-style Tabs -->
            <div class="custom-tabs-container py-3 px-4">
                <div class="custom-tabs-pill">
                    <button type="button" class="custom-tab-btn" :class="{ 'active': activeTab === 0 }"
                        @click="activeTab = 0">
                        <v-icon small class="mr-2" :class="activeTab === 0 ? 'primary--text' : 'grey--text'">
                            mdi-folder-open
                        </v-icon>
                        <span class="font-weight-bold">Documentos</span>
                    </button>
                    <button type="button" class="custom-tab-btn" :class="{ 'active': activeTab === 1 }"
                        @click="activeTab = 1">
                        <v-icon small class="mr-2" :class="activeTab === 1 ? 'primary--text' : 'grey--text'">
                            mdi-draw-pen
                        </v-icon>
                        <span class="font-weight-bold">Circuito de Aprobación (2)</span>
                    </button>
                    <button type="button" class="custom-tab-btn" :class="{ 'active': activeTab === 2 }"
                        @click="activeTab = 2">
                        <v-icon small class="mr-2" :class="activeTab === 2 ? 'primary--text' : 'grey--text'">
                            mdi-gavel
                        </v-icon>
                        <span class="font-weight-bold">Infracciones (0)</span>
                    </button>
                    <!-- Sliding indicator -->
                    <div class="tab-indicator" :style="indicatorStyle"></div>
                </div>
            </div>

            <!-- Tab Content Area -->
            <v-card-text class="pa-4 bg-slate-50 flex-grow-1 overflow-y-auto"
                style="max-height: calc(85vh - 220px); min-height: 350px;">
                <!-- Tab 0: Documentos -->
                <div v-show="activeTab === 0">
                    <s-select-definition label="" :def="1596" v-model="tempSpcType" clearable
                        @getDataInitial="getDataTypeDocuments($event)" style="display: none;" />

                    <!-- Progreso de Carga -->
                    <div class="mb-3 d-flex align-center px-1">
                        <span class="text-caption font-weight-bold text-slate-700 mr-2 flex-shrink-0">
                            Progreso de carga:
                        </span>
                        <v-progress-linear :value="uploadProgress" color="primary" height="8" rounded
                            class="rounded-pill"></v-progress-linear>
                        <span class="text-caption font-weight-bold text-slate-800 ml-2 flex-shrink-0">
                            {{ uploadProgress }}%
                        </span>
                    </div>

                    <v-row dense class="flex-column" style="gap: 8px;">
                        <v-col cols="12" v-for="doc in typeDocuments" :key="doc.DedID" class="pa-0">
                            <v-card class="document-row-card py-2 px-3 rounded-xl d-flex flex-column" flat>
                                <!-- Row 1: Document details and actions -->
                                <div class="d-flex align-center justify-space-between w-full">
                                    <div class="d-flex align-center flex-grow-1 min-w-0 mr-4">
                                        <!-- File Icon / Avatar -->
                                        <div class="doc-icon-wrapper mr-4 flex-shrink-0"
                                            :class="{ 'has-file': documentStates[doc.DedID] && documentStates[doc.DedID].file }">
                                            <v-icon size="24"
                                                :color="documentStates[doc.DedID] && documentStates[doc.DedID].file ? 'success' : 'grey lighten-1'">
                                                {{ documentStates[doc.DedID] && documentStates[doc.DedID].file ?
                                                    'mdi-file-pdf-box' :
                                                    'mdi-file-outline' }}
                                            </v-icon>
                                        </div>

                                        <!-- Details -->
                                        <div class="flex-grow-1 min-w-0">
                                            <div class="d-flex align-center flex-wrap"
                                                style="gap: 8px; margin-bottom: 2px;">
                                                <span
                                                    class="document-title font-weight-bold text-slate-800 text-truncate"
                                                    :title="doc.DedDescription">
                                                    {{ doc.DedDescription }}
                                                </span>
                                                <span :class="doc.DedHelper == 1 ? 'badge-pendiente' : 'badge-cargado'">
                                                    {{ doc.DedHelper == 1 ? 'OBLIGATORIO' : 'OPCIONAL' }}
                                                </span>
                                            </div>

                                            <!-- File status / Info -->
                                            <div v-if="!documentStates[doc.DedID] || !documentStates[doc.DedID].file || documentStates[doc.DedID].showDateConfig"
                                                class="text-caption error--text font-weight-medium">
                                                Pendiente de anexar archivo
                                            </div>
                                            <div v-else
                                                class="text-caption text-slate-500 font-medium d-flex align-center flex-wrap">
                                                <span class="mr-2"
                                                    v-if="documentStates[doc.DedID].hasDates && documentStates[doc.DedID].endDate">
                                                    Vence: <strong>
                                                        {{ $fun.formatDateView(documentStates[doc.DedID].endDate) }}
                                                    </strong>
                                                </span>
                                                <span class="text-slate-300 mr-2"
                                                    v-if="documentStates[doc.DedID].hasDates && documentStates[doc.DedID].endDate">|</span>
                                                <span class="font-mono text-slate-500 text-truncate"
                                                    style="max-width: 250px;"
                                                    :title="documentStates[doc.DedID].fileName">
                                                    FILE: {{ documentStates[doc.DedID].fileName }}
                                                </span>
                                            </div>

                                            <!-- Hidden Input for Files -->
                                            <input type="file" :ref="'fileInput_' + doc.DedID" style="display: none"
                                                accept="image/jpeg,image/jpg,image/png,application/pdf"
                                                @change="onFileChange($event, doc.DedID)">
                                        </div>
                                    </div>

                                    <!-- Action Buttons -->
                                    <div class="d-flex align-center flex-shrink-0" style="gap: 12px;">
                                        <!-- Settings Icon to Toggle Validity Inputs -->
                                        <v-btn v-if="documentStates[doc.DedID] && documentStates[doc.DedID].file" icon
                                            small :color="documentStates[doc.DedID].showDateConfig ? 'primary' : 'grey'"
                                            @click="toggleDateConfig(doc.DedID)" title="Configurar vigencia"
                                            class="rounded-lg bg-slate-100">
                                            <v-icon size="18">mdi-calendar-clock</v-icon>
                                        </v-btn>

                                        <!-- Cargar Button -->
                                        <v-btn v-if="!documentStates[doc.DedID] || !documentStates[doc.DedID].file"
                                            color="primary" class="rounded-lg px-3 text-none font-weight-bold" small
                                            depressed @click="triggerFileInput(doc.DedID)">
                                            Cargar
                                        </v-btn>

                                        <!-- Loaded File Actions -->
                                        <div v-else class="d-flex align-center" style="gap: 8px;">
                                            <v-btn icon small color="success" @click="downloadDocumentFile(doc.DedID)"
                                                title="Descargar archivo" class="download-icon-btn rounded-lg">
                                                <v-icon size="20">mdi-cloud-download-outline</v-icon>
                                            </v-btn>
                                            <v-btn icon small color="error" @click="clearFile(doc.DedID)"
                                                title="Eliminar archivo" class="delete-btn rounded-lg">
                                                <v-icon size="20">mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>

                                <!-- Inline Expandable Date Config Area nested inside the card -->
                                <v-expand-transition>
                                    <div v-if="documentStates[doc.DedID] && documentStates[doc.DedID].showDateConfig"
                                        class="date-validation-box w-full">
                                        <!-- Custom Switch Row -->
                                        <div class="d-flex align-center mb-3">
                                            <label class="d-flex align-center cursor-pointer select-none">
                                                <div class="custom-switch-wrapper mr-3">
                                                    <input type="checkbox" v-model="documentStates[doc.DedID].hasDates"
                                                        class="custom-switch-input">
                                                    <span class="custom-switch-slider"></span>
                                                </div>
                                                <span
                                                    class="text-caption font-weight-black text-slate-800 tracking-wide uppercase">
                                                    ¿ESTE DOCUMENTO REQUIERE VALIDAR FECHAS DE VIGENCIA?
                                                </span>
                                            </label>
                                        </div>

                                        <!-- Date Inputs and Validate Button Row -->
                                        <div>
                                            <v-row dense class="align-end">
                                                <v-col cols="12" sm="3" class="pr-sm-3"
                                                    v-show="documentStates[doc.DedID].hasDates">
                                                    <s-date label="Fecha Emisión"
                                                        v-model="documentStates[doc.DedID].startDate" nullable />
                                                </v-col>
                                                <v-col cols="12" sm="3" class="pr-sm-3"
                                                    v-show="documentStates[doc.DedID].hasDates">
                                                    <s-date label="Fecha Vencimiento"
                                                        v-model="documentStates[doc.DedID].endDate" nullable />
                                                </v-col>
                                                <v-col cols="12" sm="2" class="pl-sm-1">
                                                    <v-btn color="emerald"
                                                        class="white--text font-weight-bold text-none inject-btn"
                                                        :loading="documentStates[doc.DedID] && documentStates[doc.DedID].saving"
                                                        @click="saveSingleDocument(doc.DedID)" depressed>
                                                        Guardar
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </v-expand-transition>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>

                <!-- Tab 1: Circuito de Firmas -->
                <div v-show="activeTab === 1">
                    <div class="py-2">
                        <!-- Validation Section: Missing Transaction -->
                        <div v-if="selectedVehicleDetails && !selectedVehicleDetails.Transaction"
                            class="d-flex flex-column align-center justify-center py-12">
                            <v-icon size="64" color="#cbd5e1" class="mb-4">mdi-file-document-plus-outline</v-icon>
                            <h3 class="text-h6 font-weight-bold text-slate-700 mb-2">No se han encontrado circuitos de
                                aprobación</h3>
                            <p class="text-body-2 text-slate-500 mb-6 text-center" v-if="$fun.isAdmin()">
                                ¿Desea generar el circuito de aprobación para este vehículo?
                            </p>
                            <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-6" depressed
                                @click="generateCircuit" v-if="$fun.isAdmin()">
                                Generar Circuito
                            </v-btn>
                        </div>

                        <v-row v-else>
                            <!-- Left Column: Evaluación (if pending or observed) -->
                            <v-col cols="12" md="6" lg="5"
                                v-if="selectedVehicleDetails && (selectedVehicleDetails.ApprobalStatus == 1 || selectedVehicleDetails.ApprobalStatus == 2 || selectedVehicleDetails.ApprobalStatus === undefined)">
                                <div v-for="(level, index) in itemsApprovalLevels" :key="index"
                                    class="tw-confirm-card mb-1">
                                    <div class="d-flex align-center justify-space-between flex-wrap gap-2 pb-1 border-bottom"
                                        style="border-color: #f1f5f9;">
                                        <div>
                                            <div class="tw-confirm-role">CARGO</div>
                                            <!-- <div class="tw-confirm-role"
                                                v-if="infoUser.CtrContract.PstID == level.PstID">
                                                {{ infoUser.NtpFullName || '' }}
                                            </div> -->
                                            <div class="tw-confirm-user">
                                                {{ level.PstName || 'PUESTO DESCONOCIDO' }}
                                            </div>
                                        </div>
                                        <span
                                            :class="['tw-confirm-status text-uppercase', level.AtsStatus == 2 ? 'status-green' : (level.AtsStatus == 3 ? 'status-red' : 'status-orange')]">
                                            <!-- {{ level.AtsStatusName || 'PENDIENTE' }} -->
                                            {{
                                                level.AtsStatus == 2
                                                    ? 'APROBADO' : (level.AtsStatus == 3) ? 'DESAPROBADO' : level.AtsStatusName
                                            }}
                                            <!-- {{ selectedVehicleDetails && selectedVehicleDetails.ApprobalStatus == 2 ?
                                                'OBSERVADO' : 'PENDIENTE' }} -->
                                        </span>
                                    </div>

                                    <!-- Observación de Rechazo -->
                                    <div v-if="level.AtsStatus == 3 && level.AtsObservation" class="tw-confirm-obs">
                                        <div class="d-flex align-center">
                                            <v-icon size="14" color="#e11d48" class="mr-1">
                                                mdi-alert-circle-outline
                                            </v-icon>
                                            <span class="tw-confirm-obs-title">Observación:</span>
                                        </div>
                                        <div class="tw-confirm-obs-text">
                                            {{ level.AtsObservation }}
                                        </div>
                                    </div>

                                    <template
                                        v-if="infoUser && infoUser.CtrContract && infoUser.CtrContract.PstID == level.PstID && [null, 0, 1].includes(level.AtsStatus) && level.AtsAvailableApprobal == 1">
                                        <div class="d-flex align-center flex-wrap flex-sm-nowrap">
                                            <button type="button" class="tw-btn-authorize flex-grow-1 mr-1 rounded-lg"
                                                @click="approveVehicle(level)">
                                                <v-icon left size="18" color="white" class="mr-1.5">mdi-check</v-icon>
                                                APROBAR
                                            </button>
                                            <button type="button" class="tw-btn-reject rounded-lg"
                                                @click="$set(level, 'showDisapproveInput', !level.showDisapproveInput)">
                                                <v-icon left size="18" color="#e11d48" class="mr-1.5">mdi-close</v-icon>
                                                RECHAZAR
                                            </button>
                                        </div>

                                        <!-- Box de Observación de Rechazo Estricto -->
                                        <v-expand-transition>
                                            <div v-if="level.showDisapproveInput" class="tw-reject-box mt-2">
                                                <div class="tw-reject-title">Motivo del Rechazo:</div>
                                                <textarea v-model="level.disapproveObservation" rows="2"
                                                    class="tw-reject-input"
                                                    placeholder="Descripcion motivo del rechazo"></textarea>
                                                <div class="d-flex align-center justify-end mt-1 gap-2">
                                                    <button type="button" class="tw-btn-cancel mr-2 rounded-lg"
                                                        @click="$set(level, 'showDisapproveInput', false); $set(level, 'disapproveObservation', '')">
                                                        Cancelar
                                                    </button>
                                                    <button type="button" class="tw-btn-confirm-reject rounded-lg"
                                                        :disabled="!level.disapproveObservation || !level.disapproveObservation.trim()"
                                                        @click="confirmDisapprove(level)">
                                                        Confirmar Rechazo
                                                    </button>
                                                </div>
                                            </div>
                                        </v-expand-transition>
                                    </template>
                                </div>
                            </v-col>

                            <!-- Right Column: Timeline -->
                            <v-col cols="12"
                                :md="selectedVehicleDetails && (selectedVehicleDetails.ApprobalStatus == 1 || selectedVehicleDetails.ApprobalStatus == 2 || selectedVehicleDetails.ApprobalStatus === undefined) ? 6 : 12"
                                :lg="selectedVehicleDetails && (selectedVehicleDetails.ApprobalStatus == 1 || selectedVehicleDetails.ApprobalStatus == 2 || selectedVehicleDetails.ApprobalStatus === undefined) ? 7 : 12">

                                <!-- Banner Superior Dictamen de Planta -->
                                <div class="tw-dictamen-banner mb-2 d-flex align-center flex-wrap gap-2">
                                    <div>
                                        <div class="tw-dictamen-title pr-2">Estado de Aprobación Actual:</div>
                                    </div>
                                    <div v-if="selectedVehicleDetails && selectedVehicleDetails.VehStatus">
                                        <span class="tw-dictamen-pill"
                                            :class="(selectedVehicleDetails.VehStatus) == 2 ? 'pill-apto' : (selectedVehicleDetails.VehStatus == 3 ? 'pill-no-apto' : 'pill-neutral')">
                                            {{ selectedVehicleDetails.VehStatusText }}
                                        </span>
                                    </div>

                                    <div v-if="selectedVehicleDetails && selectedVehicleDetails.VehStatus == 3 && $fun.isAdmin()"
                                        class="ml-auto">
                                        <v-btn color="primary" class="rounded-lg text-none font-weight-bold" small
                                            depressed @click="regenerateCircuit">
                                            <v-icon left small>mdi-refresh</v-icon>
                                            Generar circuito
                                        </v-btn>
                                    </div>
                                </div>

                                <h3 class="text-subtitle-1 font-weight-bold text-slate-800 mb-2 px-1">
                                    Historial de Aprobaciones del Expediente
                                </h3>

                                <!-- Listado del Histórico (Super Elegant Timeline) -->
                                <div v-if="itemsApprovalHistory.length === 0"
                                    class="text-center py-8 text-slate-400 text-body-2">
                                    No hay registros de aprobaciones o desaprobaciones aún.
                                </div>
                                <div v-else class="tw-elegant-timeline pl-2 pt-1">
                                    <div v-for="(item, idx) in itemsApprovalHistory" :key="item.id || idx"
                                        class="tw-elegant-timeline-item d-flex position-relative pb-2">
                                        <!-- Continuous vertical bar connecting items -->
                                        <div v-if="idx < itemsApprovalHistory.length - 1"
                                            class="tw-elegant-timeline-line">
                                        </div>

                                        <!-- Ring Dot Node -->
                                        <div class="tw-elegant-node mr-4 flex-shrink-0 d-flex align-center justify-center"
                                            :class="item.AtsStatus == 2 ? 'node-approved' : (item.AtsStatus == 3 ? 'node-disapproved' : 'node-pending')">
                                            <div class="tw-elegant-dot"
                                                :class="item.AtsStatus == 2 ? 'dot-approved' : (item.AtsStatus == 3 ? 'dot-disapproved' : 'dot-pending')">
                                            </div>
                                        </div>

                                        <!-- Elegant White Card Content -->
                                        <div class="tw-elegant-card flex-grow-1">
                                            <div class="d-flex align-center justify-space-between flex-wrap gap-2 pb-2 border-bottom"
                                                style="border-color: #f1f5f9;">
                                                <div class="d-flex align-center">
                                                    <span class="tw-elegant-badge mr-2"
                                                        :class="item.AtsStatus == 3 ? 'badge-disapproved' : (item.AtsStatus == 2 ? 'badge-approved' : 'badge-pending')">
                                                        {{ item.AtsStatusName }}
                                                    </span>
                                                    <span class="text-body-2 font-weight-bold text-slate-800">
                                                        {{ item.TypeLevelText }}
                                                    </span>
                                                </div>
                                                <span
                                                    class="text-caption font-weight-medium text-slate-400 d-flex align-center">
                                                    <v-icon size="14" color="#94a3b8"
                                                        class="mr-1">mdi-clock-time-four</v-icon>
                                                    {{ item.AtsDateApproval }}
                                                </span>
                                            </div>

                                            <div v-if="item.AtsStatus == 3 && item.AtsObservation" class="mb-2">
                                                <div class="text-caption font-weight-medium rounded"
                                                    style="color: #e11d48 !important; font-size: 0.72rem !important; line-height: 1;">
                                                    <strong>OBSERVACIÓN:</strong> {{ item.AtsObservation }}
                                                </div>
                                            </div>

                                            <div class="tw-elegant-label mb-1">PUESTO RESPONSABLE:</div>
                                            <div class="d-flex align-center items-center text-body-2 font-weight-bold text-slate-700"
                                                style="gap: 4px;">
                                                <v-icon size="17" color="#64748b">
                                                    mdi-account-details
                                                </v-icon>
                                                {{ item.PstName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <!-- Tab 2: Infracciones -->
                <div v-show="activeTab === 2">
                    <div class="d-flex flex-column align-center justify-center py-12 px-4 text-center">
                        <div class="gavel-icon-container mb-4">
                            <v-icon size="40" color="primary">mdi-gavel</v-icon>
                        </div>
                        <h3 class="text-h6 font-weight-bold text-slate-800 mb-1">Sin Infracciones Pendientes</h3>
                        <p class="text-body-2 text-slate-500 max-w-xs mb-0">
                            Esta unidad de transporte no cuenta con multas ni infracciones pendientes de pago.
                        </p>
                    </div>
                </div>
            </v-card-text>

            <!-- Modal Footer -->
            <!-- <v-card-actions class="py-4 px-6 border-top bg-white d-flex justify-end rounded-b-xl">
                <v-btn color="slate-500" class="text-slate-700 font-weight-bold rounded-lg text-none px-5" text
                    @click="closeAuditModal()">
                    Cerrar
                </v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>

<script>
import _sVehicle from "@/services/Management/VehicleService";
import _SpcDocumentService from "@/services/SupplyChain/Transport/SpcDocumentService.js";
import _GenUploadFiles from "@/services/General/GenUploadFiles";
import _AdvanceProducerService from "@/services/Technicalassistance/AdvanceProducerService";
import _sApprovalLevel from "@/services/Security/ApprovalLevelsService";
import _sApprovalTransaction from "@/services/Security/ApprovalTransactionService";
import dayjs from 'dayjs';

export default {
    name: "VehicleAudit",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        vehId: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            activeTab: 0,
            savingDocuments: false,
            selectedVehicleDetails: null,
            typeDocuments: [],
            tempSpcType: null,
            documentStates: {},
            showDisapproveInput: false,
            disapproveObservation: "",
            circuits: [],
            itemsApprovalLevels: [],
            itemsApprovalHistory: [],
            infoUser: {},
        };
    },
    watch: {
        value(val) {
            if (val) {
                this.resetStates();
                if (this.typeDocuments && this.typeDocuments.length > 0) {
                    this.initializeDocumentStates();
                }
                this.getVehicleDetails();
                this.loadCircuits();
                this.loadApprovalLevels();
            }
        }
    },
    computed: {
        indicatorStyle() {
            const tabCount = 3;
            const step = 100 / tabCount;
            const left = this.activeTab * step;
            return {
                left: `${left}%`,
                width: `${step}%`
            };
        },
        uploadProgress() {
            if (!this.typeDocuments || this.typeDocuments.length === 0) return 0;
            let uploadedCount = 0;
            this.typeDocuments.forEach(doc => {
                const state = this.documentStates[doc.DedID];
                if (state && state.filePath) {
                    uploadedCount++;
                }
            });
            return Math.round((uploadedCount / this.typeDocuments.length) * 100);
        }
    },
    methods: {
        resetStates() {
            this.activeTab = 0;
            this.selectedVehicleDetails = null;
            this.documentStates = {};
            this.showDisapproveInput = false;
            this.itemsApprovalHistory = [];
        },
        closeAuditModal() {
            this.$emit("close");
            this.$emit('input', false);
        },
        async generateCircuit() {
            if (!this.circuits || this.circuits.length === 0) {
                this.$fun.alert("No se encontraron circuitos disponibles para generar.", "warning");
                return;
            }

            try {
                const response = await _sVehicle.saveCircuit(this.selectedVehicleDetails, this.circuits[0].AccID, this.$fun.getUserID());
                // console.log(JSON.parse(JSON.stringify(response)))
                if (response && response.status === 200) {
                    await _sVehicle.save({ ...this.selectedVehicleDetails, VehStatus: 1 }, this.$fun.getUserID());
                    this.$fun.alert("Circuito generado correctamente", "success");
                    this.getVehicleDetails();
                    this.loadCircuits();
                    this.loadApprovalLevels();
                } else {
                    this.$fun.alert("Hubo un problema al generar el circuito", "warning");
                }
            } catch (error) {
                console.error(error);
                this.$fun.alert("Error al generar el circuito", "error");
            }
        },
        async regenerateCircuit() {
            if (!this.circuits || this.circuits.length === 0) {
                this.$fun.alert("No se encontraron circuitos disponibles para generar.", "warning");
                return;
            }

            this.$fun.alert("¿Está seguro de volver a generar el circuito de aprobación?", "question").then(async (result) => {
                if (result.value) {
                    try {
                        const response = await _sVehicle.saveCircuit(this.selectedVehicleDetails, this.circuits[0].AccID, this.$fun.getUserID());
                        if (response && response.status == 200) {
                            // const payload = {...this.selectedVehicleDetails, VehStatus: 1}
                            await _sVehicle.save({ ...this.selectedVehicleDetails, VehStatus: 1 }, this.$fun.getUserID());
                            this.$fun.alert("Circuito vuelto a generar correctamente", "success");
                            this.getVehicleDetails();
                            this.loadCircuits();
                            this.loadApprovalLevels();
                        } else {
                            this.$fun.alert("Hubo un problema al volver a generar el circuito", "warning");
                        }
                    } catch (error) {
                        console.error(error);
                        this.$fun.alert("Error al volver a generar el circuito", "error");
                    }
                }
            });
        },
        async approveVehicle(item) {
            if (!this.selectedVehicleDetails) return;
            if (!this.selectedVehicleDetails.Transaction) return;

            if (!this.typeDocuments || this.typeDocuments.length === 0) {
                this.$fun.alert("Cargando documentos, por favor espere...", "warning");
                return;
            }

            const missingMandatoryDocs = this.typeDocuments.filter(doc => {
                if (doc.DedHelper == 1) {
                    const state = this.documentStates[doc.DedID];
                    return !state || !state.filePath;
                }
                return false;
            });

            if (missingMandatoryDocs.length > 0) {
                const docNames = missingMandatoryDocs.map(d => d.DedDescription).join(", ");
                this.$fun.alert(`Debe cargar todos los documentos obligatorios antes de aprobar: ${docNames}`, "warning");
                return;
            }

            this.showDisapproveInput = false;
            item.disapproveObservation = "";

            const payload = {
                // AtsAttach1: null,
                TypeApproval: 7,
                DocEntry: this.selectedVehicleDetails.VehID,
                DocumentNumber: this.selectedVehicleDetails.VehPlate,
                AtsID: this.selectedVehicleDetails.Transaction.AtsID,
                PstID: this.selectedVehicleDetails.Transaction.PstID,
                AtsStatus: 2,
                UsrIDTrigger: item.UsrCreateID,
                UsrCreateID: this.$fun.getUserID(),
                UsrUpdateID: this.$fun.getUserID(),
                AccID: item.AccID,
                AtsObservation: "",
                SecStatus: 1,
            }
            // console.log(JSON.parse(JSON.stringify({ payload })))
            this.$fun.alert("Seguro de aprobar Vehículo?", "question").then(async (r) => {
                if (r.value) {
                    try {
                        _sVehicle.approved(payload, this.$fun.getUserID()).then((rq) => {
                            this.$fun.alert("Vehículo Aprobado Correctamente", "success");
                            this.getVehicleDetails();
                            this.loadApprovalLevels();
                            this.loadCircuits();
                            // this.$set(this.selectedVehicleDetails, 'ApprobalStatus', 3);
                        });
                    } catch (error) {
                        console.error("Error al aprobar", error);
                    } finally {
                    }
                }
            });
        },
        async confirmDisapprove(item) {
            // console.log(JSON.parse(JSON.stringify({ selectedVehicleDetails: this.selectedVehicleDetails })))
            if (!item.disapproveObservation.trim() || !item.disapproveObservation) return;
            if (!this.selectedVehicleDetails.Transaction) return;

            const payload = {
                // AtsAttach1: null,
                TypeApproval: 7,
                DocEntry: this.selectedVehicleDetails.VehID,
                DocumentNumber: this.selectedVehicleDetails.VehPlate,
                AtsID: this.selectedVehicleDetails.Transaction.AtsID,
                PstID: this.selectedVehicleDetails.Transaction.PstID,
                AtsStatus: 3,
                UsrIDTrigger: item.UsrCreateID,
                UsrCreateID: this.$fun.getUserID(),
                UsrUpdateID: this.$fun.getUserID(),
                AccID: item.AccID,
                AtsObservation: item.disapproveObservation.trim(),
                SecStatus: 1,
            }
            // console.log(JSON.parse(JSON.stringify({ payload })))
            this.$fun.alert("Seguro de desaprobar Vehículo?", "question").then((r) => {
                if (r.value) {
                    try {
                        _sVehicle.approved(payload, this.$fun.getUserID()).then((rq) => {
                            this.$fun.alert("Vehículo desaprobado", "success");
                            this.getVehicleDetails();
                            this.loadApprovalLevels();
                            this.loadCircuits();
                            // this.$set(this.selectedVehicleDetails, 'ApprobalStatus', 3);
                        });
                    } catch (error) {
                        console.error("Error al aprobar", error);
                    } finally {
                    }
                }
            });
        },
        async getVehicleDetails() {
            if (!this.vehId) return;
            try {
                const response = await _sVehicle.get({ VehID: this.vehId }, this.$fun.getUserID());
                if (response && response.data) {
                    this.selectedVehicleDetails = response.data;
                    // console.log(JSON.parse(JSON.stringify(this.selectedVehicleDetails)))
                    if (this.selectedVehicleDetails.ApprobalStatus === undefined || this.selectedVehicleDetails.ApprobalStatus === null) {
                        this.$set(this.selectedVehicleDetails, 'ApprobalStatus', 1);
                    }
                    this.loadDocumentsData();
                    this.fetchExistingDocuments();
                }
            } catch (error) {
                console.error("Error fetching vehicle details:", error);
            }
        },
        getDataTypeDocuments(items) {
            this.typeDocuments = items || [];
            // console.log(JSON.parse(JSON.stringify(items)))
            this.initializeDocumentStates();
        },
        initializeDocumentStates() {
            if (!this.typeDocuments || this.typeDocuments.length === 0) return;

            this.typeDocuments.forEach(doc => {
                this.$set(this.documentStates, doc.DedID, {
                    SpcdID: 0,
                    file: null,
                    fileName: '',
                    filePath: '',
                    startDate: null,
                    endDate: null,
                    hasDates: false,
                    showDateConfig: false,
                    saving: false
                });
            });

            this.fetchExistingDocuments();
        },
        fetchExistingDocuments() {
            if (!this.selectedVehicleDetails || !this.selectedVehicleDetails.Documents) return;
            if (!this.typeDocuments || this.typeDocuments.length === 0) return;
            if (!this.documentStates || Object.keys(this.documentStates).length === 0) return;

            const docs = this.selectedVehicleDetails.Documents;
            docs.forEach(d => {
                if (d.SecStatus === 0) return;
                const docDef = this.typeDocuments.find(x => x.DedValue === d.SpcType);
                if (docDef) {
                    const state = this.documentStates[docDef.DedID];
                    if (state) {
                        state.SpcdID = d.SpcdID;
                        state.file = d.SpcFilename ? { name: d.SpcFilename } : null;
                        state.fileName = d.SpcFilename || '';
                        state.filePath = d.SpcFilePath || '';
                        state.startDate = d.SpcStartDate ? dayjs(d.SpcStartDate).format('YYYY-MM-DD') : null;
                        state.endDate = d.SpcExpireDate ? dayjs(d.SpcExpireDate).format('YYYY-MM-DD') : null;
                        state.hasDates = !!(d.SpcStartDate || d.SpcExpireDate);
                    }
                }
            });
        },
        loadDocumentsData() {
            this.tempSpcType = null;
        },
        triggerFileInput(dedId) {
            const refName = `fileInput_${dedId}`;
            const inputEl = this.$refs[refName];
            if (inputEl && inputEl[0]) {
                inputEl[0].click();
            }
        },
        onFileChange(event, dedId) {
            const files = event.target.files;
            if (files && files.length > 0) {
                const file = files[0];

                // Validate type
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(file.type)) {
                    this.$fun.alert("Formato de archivo no permitido. Solo se permiten PDFs e imágenes (JPG, PNG).", "error");
                    event.target.value = '';
                    return;
                }

                // Validate size (max 5MB)
                if (file.size > 5 * 1024 * 1024) {
                    this.$fun.alert("El archivo excede el tamaño máximo permitido de 5MB.", "error");
                    event.target.value = '';
                    return;
                }

                const state = this.documentStates[dedId];
                if (state) {
                    state.file = file;
                    state.fileName = file.name;
                    state.showDateConfig = true; // Auto open date config for validation upon upload
                }
            }
            event.target.value = '';
        },
        clearFile(dedId) {
            const state = this.documentStates[dedId];
            if (!state) return;

            if (state.SpcdID > 0) {
                this.$fun.alert("¿Está seguro de eliminar este documento?", "question").then(async (val) => {
                    if (!val || !val.value) return;

                    const doc = this.typeDocuments.find(x => x.DedID === dedId);
                    try {
                        await this.saveDocument({
                            SpcdID: state.SpcdID,
                            VehID: this.vehId,
                            SpcID: this.selectedVehicleDetails ? this.selectedVehicleDetails.SpcID : null,
                            SpcType: doc ? doc.DedValue : 0,
                            SpcFilename: state.fileName,
                            SpcFilePath: state.filePath,
                            SpcStartDate: state.hasDates ? state.startDate : null,
                            SpcExpireDate: state.hasDates ? state.endDate : null,
                            SecStatus: 0,
                            UsrCreateID: this.$fun.getUserID()
                        });

                        this.resetSectionState(state);
                        await this.getVehicleDetails();
                        this.$emit('save');
                        this.$emit('saved');
                        this.$fun.alert("Documento eliminado correctamente.", "success");
                    } catch (e) {
                        console.error("Error al eliminar documento:", e);
                        this.$fun.alert("Error al eliminar el documento.", "error");
                    }
                });
            } else {
                this.resetSectionState(state);
            }
        },
        resetSectionState(state) {
            state.SpcdID = 0;
            state.file = null;
            state.fileName = '';
            state.filePath = '';
            state.startDate = null;
            state.endDate = null;
            state.hasDates = false;
            state.showDateConfig = false;
        },
        toggleDateConfig(dedId) {
            const state = this.documentStates[dedId];
            if (state) {
                state.showDateConfig = !state.showDateConfig;
            }
        },
        async saveSingleDocument(dedId) {
            const state = this.documentStates[dedId];
            if (!state) return;

            if (state.hasDates) {
                if (!state.startDate || !state.endDate) {
                    this.$fun.alert("Por favor complete ambas fechas de vigencia.", "warning");
                    return;
                }
                if (dayjs(state.endDate).isBefore(dayjs(state.startDate))) {
                    this.$fun.alert("La fecha de vencimiento no puede ser anterior a la de emisión.", "warning");
                    return;
                }
            }

            if (!state.file) {
                this.$fun.alert("Por favor cargue un archivo primero.", "warning");
                return;
            }

            state.saving = true;
            const vehId = this.vehId;
            const doc = this.typeDocuments.find(x => x.DedID === dedId);

            try {
                let finalPath = state.filePath;
                if (state.file instanceof File) {
                    const cleanType = doc.DedDescription
                        ? doc.DedDescription.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Z0-9]/g, "_").replace(/_+/g, "_").replace(/(^_|_$)/g, "")
                        : 'ADJUNTO';
                    const uniqueFileName = `${cleanType}_${dayjs().format('YYYYMMDD_HHmmss')}`.toUpperCase();

                    const uploadRes = await this.loadFileOnServer(state.file, uniqueFileName);
                    if (uploadRes.success) {
                        finalPath = uploadRes.path;
                        state.fileName = uploadRes.fileName;
                        state.filePath = uploadRes.path;
                        state.file = { name: uploadRes.fileName };
                    } else {
                        throw new Error(`No se pudo subir el archivo: ${state.fileName}`);
                    }
                }

                await this.saveDocument({
                    SpcdID: state.SpcdID,
                    VehID: vehId,
                    SpcID: this.selectedVehicleDetails ? this.selectedVehicleDetails.SpcID : null,
                    SpcType: doc.DedValue,
                    SpcFilename: state.fileName,
                    SpcFilePath: finalPath,
                    SpcStartDate: state.hasDates ? state.startDate : null,
                    SpcExpireDate: state.hasDates ? state.endDate : null,
                    SecStatus: 1,
                    UsrCreateID: this.$fun.getUserID()
                });

                await this.getVehicleDetails();
                state.showDateConfig = false;
                this.$fun.alert("Documento guardado con éxito.", "success");
                this.$emit('save');
                this.$emit('saved');
            } catch (e) {
                console.error("Error saving document:", e);
                this.$fun.alert("Error al guardar el documento. Verifique la conexión o el formato del archivo.", "error");
            } finally {
                state.saving = false;
            }
        },
        async loadFileOnServer(file, fileName) {
            try {
                const response = await _GenUploadFiles.upload(file, fileName, 'PathDocumentCarrier', true);
                if (response && response.status === 200 && response.data) {
                    return {
                        success: true,
                        fileName: response.data.fileName,
                        path: response.data.path
                    };
                }
                return { success: false };
            } catch (e) {
                console.error("Error uploading file to server:", e);
                return { success: false };
            }
        },
        async saveDocument(payload) {
            return await _SpcDocumentService.save(payload, this.$fun.getUserID());
        },
        async saveAllDocuments() {
            this.$fun.alert("¿Está seguro que desea guardar los cambios en la documentación del vehículo?", "question").then(async (val) => {
                if (!val || !val.value) return;

                this.savingDocuments = true;
                const vehId = this.vehId;

                try {
                    for (const doc of this.typeDocuments) {
                        const state = this.documentStates[doc.DedID];
                        if (!state || !state.file) continue;

                        let finalPath = state.filePath;
                        if (state.file instanceof File) {
                            const cleanType = doc.DedDescription
                                ? doc.DedDescription.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Z0-9]/g, "_").replace(/_+/g, "_").replace(/(^_|_$)/g, "")
                                : 'ADJUNTO';
                            const uniqueFileName = `${cleanType}_${dayjs().format('YYYYMMDD_HHmmss')}`.toUpperCase();

                            const uploadRes = await this.loadFileOnServer(state.file, uniqueFileName);
                            if (uploadRes.success) {
                                finalPath = uploadRes.path;
                                state.fileName = uploadRes.fileName;
                                state.filePath = uploadRes.path;
                            } else {
                                throw new Error(`No se pudo subir el archivo: ${state.fileName}`);
                            }
                        }

                        await this.saveDocument({
                            SpcdID: state.SpcdID,
                            VehID: vehId,
                            SpcID: this.selectedVehicleDetails ? this.selectedVehicleDetails.SpcID : null,
                            SpcType: doc.DedValue,
                            SpcFilename: state.fileName,
                            SpcFilePath: finalPath,
                            SpcStartDate: state.hasDates ? state.startDate : null,
                            SpcExpireDate: state.hasDates ? state.endDate : null,
                            SecStatus: 1,
                            UsrCreateID: this.$fun.getUserID(),
                        });
                    }
                    this.$fun.alert("Documentación guardada con éxito.", "success");
                    this.closeAuditModal();
                    this.$emit('save');
                    this.$emit('saved');
                } catch (e) {
                    console.error("Error saving documents:", e);
                    this.$fun.alert("Error al guardar los documentos. Verifique la conexión o el formato del archivo.", "error");
                } finally {
                    this.savingDocuments = false;
                }
            });
        },
        downloadDocumentFile(dedId) {
            const state = this.documentStates[dedId];
            console.log(JSON.parse(JSON.stringify(state)))
            if (state && state.fileName) {
                // window.open(state.filePath, '_blank');
                _GenUploadFiles.getFile("PathDocumentCarrier", `${state.fileName}`)
                    .then(resp => console.log('downloaded : ', resp))
                    .catch(error => console.error("Error al obtener archivo:", error));

            }
        },
        loadCircuits() {
            const obj = {
                UsrCreateID: this.$fun.getUserID(),
                TypeApproval: 7,
                TransactionID: 1,
                DocEntry: 0,
            };

            _AdvanceProducerService.getCircuits(obj, this.$fun.getUserID()).then((r) => {
                this.circuits = r.status == 200 ? r.data : [];
                // console.log(JSON.parse(JSON.stringify({ circuits: this.circuits })))
                if (this.circuits.length > 0) {
                    this.loadApprovalHistory(this.circuits[0].AccID);
                }
            });
        },
        loadApprovalLevels() {
            _sApprovalLevel.byDocument({ DocEntry: this.vehId, TypeApproval: 7 }, this.$fun.getUserID()).then((r) => {
                // console.log(JSON.parse(JSON.stringify({ itemsApprovalLevels: r.data })))
                this.itemsApprovalLevels = r.data;
            });
        },
        loadApprovalHistory(AccID) {
            _sApprovalTransaction.history({ DocEntry: this.vehId, TypeApproval: 7, AccID }, this.$fun.getUserID()).then((r) => {
                this.itemsApprovalHistory = r.status == 200 ? r.data : [];
                // console.log(JSON.parse(JSON.stringify({ itemsApprovalHistory: this.itemsApprovalHistory })))
            });
        }
    },
    async created() {
        this.infoUser = this.$fun.getUserInfo();
        // console.log(JSON.parse(JSON.stringify(this.infoUser)))
    }
}
</script>

<style scoped>
.block {
    display: block;
}

.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text-slate-900 {
    color: #0f172a;
}

.text-slate-800 {
    color: #1e293b;
}

.text-slate-500 {
    color: #64748b;
}

.bg-slate-50 {
    background-color: #f8fafc;
}

.bg-slate-100 {
    background-color: #f1f5f9 !important;
}

.border-top {
    border-top: 1px solid #e2e8f0;
}

.plate-badge {
    background-color: #ffffff;
    color: #1e293b;
    border: 2px solid #ffffff;
    font-weight: 800;
    font-family: ui-monospace, monospace;
    padding: 3px 10px;
    border-radius: 8px;
    font-size: 0.85rem;
    letter-spacing: 0.05em;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    display: inline-block;
}

.close-icon-btn {
    opacity: 0.85;
    transition: opacity 0.2s;
}

.close-icon-btn:hover {
    opacity: 1;
}

.custom-tabs-container {
    background-color: #ffffff;
    border-bottom: 1px solid #e2e8f0;
}

.custom-tabs-pill {
    position: relative;
    display: flex;
    background-color: #f1f5f9;
    border-radius: 12px;
    padding: 2px;
    user-select: none;
}

.custom-tab-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    font-size: 0.875rem;
    color: #64748b;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 2;
    transition: color 0.3s;
}

.custom-tab-btn.active {
    color: #0b0f19;
}

.tab-indicator {
    position: absolute;
    top: 2px;
    bottom: 2px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    z-index: 1;
    transition: left 0.3s ease;
}

.document-row-card {
    border: 1px solid #f1f5f9 !important;
    background-color: #ffffff !important;
    transition: all 0.2s;
}

.doc-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #f8fafc;
    border: 1px solid #f1f5f9;
    border-radius: 8px;
}

.doc-icon-wrapper.has-file {
    background-color: #ecfdf5;
    border-color: #d1fae5;
}

.document-title {
    font-size: 0.95rem;
    color: #1e293b;
}

.badge-cargado {
    font-size: 0.65rem;
    font-weight: 800;
    color: #15803d;
    background-color: #dcfce7;
    padding: 2px 8px;
    border-radius: 6px;
}

.badge-pendiente {
    font-size: 0.65rem;
    font-weight: 800;
    color: #b91c1c;
    background-color: #fee2e2;
    padding: 2px 8px;
    border-radius: 6px;
}

.download-icon-btn {
    background-color: #ecfdf5 !important;
    border: 1px solid #d1fae5 !important;
    color: #10b981 !important;
}

.delete-btn {
    background-color: #fef2f2 !important;
    border: 1px solid #fee2e2 !important;
    color: #ef4444 !important;
}

.custom-switch-wrapper {
    position: relative;
    width: 44px;
    height: 24px;
}

.custom-switch-input {
    opacity: 0;
    width: 0;
    height: 0;
}

.custom-switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: .3s;
    border-radius: 24px;
}

.custom-switch-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.custom-switch-input:checked+.custom-switch-slider {
    background-color: #2563eb;
}

.custom-switch-input:checked+.custom-switch-slider:before {
    transform: translateX(20px);
}

.w-full {
    width: 100% !important;
}

/* Date validation container box styling inside the card */
.date-validation-box {
    background-color: #f8fafc;
    border-top: 1px solid #f1f5f9 !important;
    margin-top: 10px;
    padding: 10px 0 2px 0;
    transition: all 0.3s ease;
}

.inject-btn {
    background-color: #059669 !important;
    color: white !important;
    height: 36px !important;
    border-radius: 10px !important;
}

.inject-btn:hover {
    background-color: #047857 !important;
}

/* Approval history badge colors */
.bg-success-light {
    background-color: #ecfdf5;
}

.bg-warning-light {
    background-color: #fffbef;
}

/* Placeholder gavel icon styling */
.gavel-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background-color: #eff6ff;
    border-radius: 50%;
    animation: pulse 2.5s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.15);
    }

    70% {
        transform: scale(1.04);
        box-shadow: 0 0 0 12px rgba(59, 130, 246, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
    }
}

/* Elegant Dark Banner */
.tw-dictamen-banner {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tw-dictamen-sub {
    font-size: 0.65rem;
    font-weight: 800;
    color: #94a3b8;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 2px;
}

.tw-dictamen-title {
    font-size: 1.05rem;
    font-weight: 800;
    color: #1e293b;
    letter-spacing: -0.01em;
}

.tw-dictamen-pill {
    font-size: 0.78rem;
    font-weight: 800;
    padding: 6px 12px;
    border-radius: 8px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.pill-apto {
    background-color: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
}

.pill-no-apto {
    background-color: #fff1f2;
    color: #e11d48;
    border: 1px solid #fecdd3;
}

.pill-eval {
    background-color: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

/* Super Elegant Timeline Matching Screenshot */
.tw-elegant-timeline {
    position: relative;
}

.tw-elegant-timeline-item {
    position: relative;
}

.tw-elegant-timeline-line {
    position: absolute;
    left: 13.5px;
    top: 32px;
    bottom: -6px;
    width: 1px;
    background-color: #cbd5e1;
    z-index: 1;
}

.tw-elegant-node {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    z-index: 2;
    margin-top: 2px;
}

.node-approved {
    background-color: #a7f3d0;
}

.node-disapproved {
    background-color: #fecaca;
}

.node-pending {
    background-color: #fde68a;
}

.tw-elegant-dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
}

.dot-approved {
    background-color: #10b981;
}

.dot-disapproved {
    background-color: #ef4444;
}

.dot-pending {
    background-color: #f59e0b;
}

.tw-elegant-card {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 6px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
    transition: all 0.2s ease;
}

.tw-elegant-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.04);
}

.tw-elegant-badge {
    font-size: 0.72rem;
    font-weight: 800;
    padding: 3px 10px;
    border-radius: 6px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.badge-approved {
    background-color: #ecfdf5;
    color: #047857;
}

.badge-disapproved {
    background-color: #fef2f2;
    color: #b91c1c;
}

.badge-pending {
    background-color: #fffbeb;
    color: #b45309;
}

.tw-elegant-label {
    font-size: 0.68rem;
    font-weight: 800;
    color: #94a3b8;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

/* Exact Screenshot Confirmation/Rejection Form */
.tw-confirm-card {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 1.2rem;
    padding: 6px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03);
}

.tw-confirm-role {
    font-size: 0.7rem;
    font-weight: 800;
    color: #94a3b8;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tw-confirm-user {
    font-size: 0.9rem;
    font-weight: 800;
    color: #1e293b;
}

.tw-confirm-status {
    background-color: #f1f5f9;
    color: #475569;
    font-size: 0.75rem;
    line-height: 0.85rem;
    font-weight: 800;
    padding: 5px 8px;
    border-radius: 8px;
    letter-spacing: 0.03em;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.tw-confirm-status.status-green {
    background-color: #059669;
    color: #ffffff;
}

.tw-confirm-status.status-red {
    background-color: #e11d48;
    color: #ffffff;
}

.tw-confirm-status.status-orange {
    background-color: #ddd;
    color: #555;
}

.tw-btn-authorize {
    background-color: #059669;
    color: #ffffff;
    border: none;
    font-weight: 700;
    font-size: 0.92rem;
    padding: 7px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tw-btn-authorize:hover {
    background-color: #047857;
}

.tw-btn-reject {
    background-color: #fee2e2;
    color: #e11d48;
    border: none;
    font-weight: 700;
    font-size: 0.92rem;
    padding: 7px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tw-btn-reject:hover {
    background-color: #fecdd3;
}

.tw-reject-box {
    background-color: #fff1f2;
    border: 1px solid #fecdd3;
    border-radius: 10px;
    padding: 6px 8px;
}

.tw-reject-title {
    font-size: 0.8rem;
    font-weight: 800;
    color: #9f1239;
    margin-bottom: 2px;
}

.tw-reject-input {
    background-color: #ffffff;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    padding: 4px 8px;
    font-size: 0.88rem;
    color: #334155;
    width: 100%;
    outline: none;
    transition: border-color 0.2s;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.tw-reject-input:focus {
    border-color: #e11d48;
}

.tw-btn-cancel {
    background-color: #e11d48;
    border: none;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    padding: 8px 18px;
}

.tw-btn-confirm-reject {
    background-color: #1a5cff;
    color: #ffffff;
    border: none;
    font-weight: 700;
    font-size: 0.85rem;
    padding: 8px 18px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(225, 29, 72, 0.2);
}

.tw-btn-confirm-reject:disabled {
    background-color: #b0c6ff;
    cursor: not-allowed;
    box-shadow: none;
}

.pill-neutral {
    background-color: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

/* Custom styles for rejection observation box */
.tw-confirm-obs {
    background-color: #fff1f2;
    border: 1px solid #fecdd3;
    border-radius: 8px;
    padding: 6px 10px;
}

.tw-confirm-obs-title {
    font-size: 0.72rem;
    font-weight: 800;
    color: #e11d48;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tw-confirm-obs-text {
    font-size: 0.78rem;
    font-weight: 500;
    color: #4f4f4f;
    line-height: 1.25;
}
</style>
